import React from "react";
import logo from "./logo.svg";
import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
// import Login from "./views/Customer_pro/Login";
// import Dashboard from "./views/Customer_pro/Dashboard";
import Customer_orders from "./views/Customer_pro/Customer_orders";
// import Register from "./views/Customer_pro/Register";
// import Forgot_password from "./views/Customer_pro/Forgot_password";
// import Create_password from "./views/Customer_pro/Create_password";
import Verify_email from "./views/Customer_pro/Verify_email";
import Bulk_order_log from "./views/Customer_pro/Bulk_order_log";
import Bulk_orders_log_detail from "./views/Customer_pro/Bulk_orders_log_detail";
import Create_order_1 from "./views/Customer_pro/Create_order_1";
import Create_order_2 from "./views/Customer_pro/Create_order_2";
import Create_order_3 from "./views/Customer_pro/Create_order_3";
import Create_order_4 from "./views/Customer_pro/Create_order_4";
import Order_import from "./views/Customer_pro/Order_import";
import Detail_summary from "./views/Customer_pro/Detail_summary";
// import Channel_list from "./views/Customer_pro/Channel_list";
import Channel_list from "./views/Customer_elite/Channel_list";

import Add_channel from "./views/Customer_pro/Add_channel";
// import Channel_integrate from "./views/Customer_pro/Channel_integrate";
import Shipments from "./views/Customer_pro/Shipments";
// import Master_label_settings from "./views/Customer_pro/Master_label_settings";
import Label_size_settings from "./views/Customer_pro/Label_size_settings";
// import Pickup_request from "./views/Customer_pro/Pickup_request";
// import Warehouse from "./views/Customer_pro/Warehouse";
import Warehouse from "./views/Customer_elite/Warehouse";

// import Weight_discrepancies_list from "./views/Customer_pro/Weight_discrepancies_list";
import Rate_calculator from "./views/Customer_elite/Rate_calculator";
import Order_allocation from "./views/Customer_elite/Order_allocation";
// import After_ship from "./views/Customer_elite/After_ship";
import After_ship from "./views/Customer_elite/Aftership";
// import Aftership_tracking_script from "./views/Customer_elite/Aftership_tracking_script";
import Aftership_tracking_script from "./views/Customer_elite/Aftership_tracking_script";
// import Billing_shipping_charges from "./views/Customer_pro/Billing_shipping_charges";
import Billing_shipping_charges from "./views/Customer_elite/Billing_shipping_charges";

// import Deduction from "./views/Customer_pro/Deduction";
import Billing_deduction from "./views/Customer_elite/Billing_deduction";
// import Recharge from "./views/Customer_pro/Recharge";
import Billing_recharge from "./views/Customer_elite/Billing_recharge";
// import Billing_weight_reconciliation from "./views/Customer_pro/Billing_weight_reconciliation";
import Billing_weight_reconciliation from "./views/Customer_elite/Billing_weight_reconciliation";
// import Billing_cod_remittance from "./views/Customer_pro/Billing_cod_remittance";
import Billing_cod_remittance from "./views/Customer_elite/Billing_cod_remittance";

// import Billing_wallet from "./views/Customer_pro/Billing_wallet";
import Billing_passbook from "./views/Customer_elite/Billing_passbook";
import Billing_refunded from "./views/Customer_elite/Billing_refunded";
import Reports from "./views/Customer_pro/Reports";
import Customer_invoice from "./views/Customer_pro/Customer_invoice";
import Invoice_vendor from "./views/Customer_skyship/Invoice_vendor";
import Profile_update from "./views/Customer_elite/Profile_update";
import Bank_details from "./views/Customer_elite/Bank_details";
// import User_kyc from "./views/Customer_pro/User_kyc";
import Billing_address from "./views/Customer_elite/Billing_address";
import Change_password from "./views/Customer_elite/Change_password";
import Email_notifications from "./views/Customer_pro/Email_notifications";
// import Whatsapp_notification from "./views/Customer_pro/Whatsapp_notification";
import Whatsapp_notification from "./views/Customer_elite/Whatsapp_notification";
import Sms_notification from "./views/Customer_elite/Sms_notification";
import Wallet_recharge from "./views/Customer_pro/Wallet_recharge";
import Tracking from "./views/Customer_pro/Tracking";
// import Print_label from "./views/Customer_pro/Print_label";
import Print_label from "./views/Customer_elite/Print_label";
// import Support_tickets from "./views/Customer_pro/Support_tickets";
import Support_tickets from "./views/Customer_elite/Support_tickets";

import Create_ticket from "./views/Customer_pro/Create_ticket";
import Support_create_ticket from "./views/Customer_elite/Support_create_ticket";

import Ticket_details from "./views/Customer_pro/Ticket_details";
import Support_tickets_details from "./views/Customer_elite/Support_tickets_details";

import Activity_logs from "./views/Customer_pro/Activity_logs";
// import Settings from "./views/Customer_pro/Settings";
import Settings from "./views/Customer_elite/Settings";

import International_orders from "./views/Customer_pro/International_orders";
import International_order_import from "./views/Customer_pro/International_order_import";
// import Ndr from "./views/Customer_pro/Ndr";
import Ndr_v2 from "./views/Customer_elite/Ndr_v2";
import Transaction_detail from "./views/Customer_pro/Transaction_detail";
import Manifest_add from "./views/Customer_pro/Manifest_add";
// import Manifest_list from "./views/Customer_pro/Manifest_list";
import Manifest_list from "./views/Customer_elite/Manifest_list";

// import Manifest_print from "./views/Customer_pro/Manifest_print";
import Manifest_print from "./views/Customer_elite/Manifest_print";

import Bulk_lb_print from "./views/Customer_pro/Bulk_lb_print";
import System_prefrences from "./views/Customer_pro/System_prefrences";
import Create_order_b2b_1 from "./views/Customer_pro/Create_order_b2b_1";
import Create_order_b2b_2 from "./views/Customer_pro/Create_order_b2b_2";
import Create_order_b2b_3 from "./views/Customer_pro/Create_order_b2b_3";
import Customer_b2b_orders from "./views/Customer_pro/Customer_b2b_orders";
import Verify_sms from "./views/Customer_pro/Verify_sms";
import Weight_discrepancies_list_b2b from "./views/Customer_pro/Weight_discrepancies_list_b2b";
import Pickup_request_b2b from "./views/Customer_pro/Pickup_request_b2b";
import My_referrals from "./views/Customer_pro/My_referrals";
import My_earnings from "./views/Customer_pro/My_earnings";
import Print_label_b2b from "./views/Customer_pro/Print_label_b2b";
import Rate_card_b2b from "./views/Customer_pro/Rate_card_b2b";
import Rate_card_b2c from "./views/Customer_pro/Rate_card_b2c";
import RedirectHandler from "./views/Customer_pro/RedirectHandler";
import PayNowButton from "./views/Customer_pro/PayNowButton";
import Privacy from "./views/Customer_pro/Privacy";
import Manage_product from "./views/Customer_pro/Manage_product";
import Create_product from "./views/Customer_pro/Create_product";
import Vas from "./views/Customer_pro/Vas";
import Channel_integrate_new from "./views/Customer_pro/Channel_integrate_new";
import ShopifyDirectInstall from "./views/Customer_pro/ShopifyDirectInstall";
// import Rate_card from "./views/Customer_pro/Rate_card";
import Rate_card from "./views/Customer_elite/Rate_card";

import Rto_pricing from "./views/Customer_pro/Rto_pricing";
import B2B_pricing from "./views/Customer_pro/B2B_pricing";
// import ShopifyConnect from "./views/Customer_pro/ShopifyConnect";
import Login from "./views/Customer_elite/Login";
import Register from "./views/Customer_elite/Register";
import Forgot from "./views/Customer_elite/Forgot";
import Create_password from "./views/Customer_elite/Create_password";
import Forgot_otp from "./views/Customer_elite/Forgot_otp";
import Index from "./views/Customer_elite/Index";
import Kyc from "./views/Customer_elite/Kyc";
import Create_order from "./views/Customer_elite/Create_order";
import Orders from "./views/Customer_elite/Orders";
import Weight_discrepancies_list from "./views/Customer_elite/Weight_discrepancies_list";
import Shipment_report_v2 from "./views/Customer_elite/Shipment_report_v2";
import Invoices_list from "./views/Customer_elite/Invoices_list";
import Team from "./views/Customer_elite/Team";
import Support_faq from "./views/Customer_elite/Support_faq";
import Developer_apis from "./views/Customer_elite/Developer_apis";
import Master_label_settings from "./views/Customer_elite/Master_label_settings";
import Label_settings from "./views/Customer_elite/Label_settings";
import Recharge_wallet from "./views/Customer_elite/Recharge_wallet";
import Email_notification from "./views/Customer_elite/Email_notification";
import System_preference from "./views/Customer_elite/System_preference";
import Create_team_user from "./views/Customer_elite/Create_team_user";
import Bulk_order_log_detail from "./views/Customer_elite/Bulk_order_log_detail";
import Shipment_report from "./views/Customer_elite/Shipment_report";
import ShippingProgressBar from "./views/Customer_elite/setShipNowOpen";
import ShopifyConnect from "./views/Customer_elite/ShopifyConnect";
import Channel_integrate from "./views/Customer_elite/Channel_integrate";
import Pickup_request from "./views/Customer_elite/Pickup_request";
import Notification_settings from "./views/Customer_elite/Notification_settings";
import Shipping_rules from "./views/Customer_elite/Shipping_rules";
import Shipping_rule_edit from "./views/Customer_elite/Shipping_rule_edit";
import Bulk_order_log_detail_new from "./views/Customer_elite/Bulk_order_log_detail_new";

function App() {
  const userDetail = localStorage.getItem("ship_rocket_user");
  const isLoggedIn = Boolean(userDetail);

  console.log("userDetail 111===>   ", userDetail);
  return (
    <Router>
      <Routes>
        {isLoggedIn ? (
          <Route path="/" element={<Navigate to="/index" replace />} />
        ) : (
          <Route path="/" element={<Navigate to="/login" replace />} />
        )}

        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot_password" element={<Forgot />} />
        <Route path="/create_password" element={<Create_password />} />
        <Route path="/forgot_otp" element={<Forgot_otp />} />

        <Route path="/verify_email" element={<Verify_email />} />
        <Route path="/verify_sms" element={<Verify_sms />} />

        <Route path="/index" element={<Index />} />

        {/* <Route path="/dashboard" element={<Dashboard />} /> */}
        {/* <Route path="/orders" element={<Customer_orders />} /> */}
        <Route path="/orders" element={<Orders />} />

        <Route path="/b2b_orders" element={<Customer_b2b_orders />} />

        <Route path="/bulk_orders_log/:log_id" element={<Bulk_order_log />} />
        <Route path="/create_order_1" element={<Create_order_1 />} />
        <Route path="/create_order_b2b_1" element={<Create_order_b2b_1 />} />

        <Route path="/create_order_2" element={<Create_order_2 />} />
        <Route path="/create_order_b2b_2" element={<Create_order_b2b_2 />} />

        <Route path="/create_order_3" element={<Create_order_3 />} />
        <Route path="/create_order_b2b_3" element={<Create_order_b2b_3 />} />

        <Route path="/create_order_4" element={<Create_order_4 />} />
        <Route path="/bulk_order_upload" element={<Order_import />} />
        <Route path="/detail_summary/:record_id" element={<Detail_summary />} />
        {/* <Route
          path="/bulk_order_log_detail"
          element={<Bulk_order_log_detail />}
        /> */}

        <Route
          path="/bulk_order_log_detail"
          element={<Bulk_order_log_detail_new />}
        />

        {/* <Route path="/channel_list" element={<Channel_list />} /> */}
        <Route path="/channel_list" element={<Channel_list />} />

        <Route path="/add_channel" element={<Add_channel />} />
        <Route path="/shipments" element={<Shipments />} />
        {/* <Route
          path="/master_label_settings"
          element={<Master_label_settings />}
        /> */}
        <Route
          path="/master_label_settings"
          element={<Master_label_settings />}
        />
        <Route path="/label_settings" element={<Label_settings />} />
        <Route path="/recharge_wallet" element={<Recharge_wallet />} />

        {/* <Route path="/label_size_settings" element={<Label_size_settings />} /> */}
        <Route path="/pickup_request" element={<Pickup_request />} />
        <Route path="/pickup_request_b2b" element={<Pickup_request_b2b />} />
        <Route path="/warehouse" element={<Warehouse />} />
        <Route path="/my_referrals" element={<My_referrals />} />
        <Route path="/my_earnings" element={<My_earnings />} />

        <Route
          path="/weight_discrepancies_list"
          element={<Weight_discrepancies_list />}
        />
        <Route
          path="/weight_discrepancies_list_b2b"
          element={<Weight_discrepancies_list_b2b />}
        />
        <Route path="/rate_calculator" element={<Rate_calculator />} />
        <Route path="/order_allocation" element={<Order_allocation />} />
        <Route path="/aftership" element={<After_ship />} />
        <Route
          path="/aftership_tracking_script"
          element={<Aftership_tracking_script />}
        />

        <Route path="/channel_integrate" element={<Channel_integrate />} />
        <Route path="/shopify_connect" element={<ShopifyConnect />} />

        <Route
          path="/channel_integrate_new/:channel_id"
          element={<Channel_integrate_new />}
        />

        <Route
          path="/bulk_orders_log_detail/:log_id"
          element={<Bulk_orders_log_detail />}
        />
        <Route
          path="/billing_shipping_charges"
          element={<Billing_shipping_charges />}
        />
        <Route
          path="/billing_cod_remittance"
          element={<Billing_cod_remittance />}
        />

        {/* <Route path="/billing_deduction" element={<Deduction />} /> */}
        <Route path="/billing_deduction" element={<Billing_deduction />} />
        <Route path="/developer_apis" element={<Developer_apis />} />

        <Route path="/privacy" element={<Privacy />} />
        <Route path="/manage_product" element={<Manage_product />} />
        <Route path="/create_product" element={<Create_product />} />
        <Route path="/vas" element={<Vas />} />
        <Route
          path="/notification_settings"
          element={<Notification_settings />}
        />
        <Route path="/shipping_rules" element={<Shipping_rules />} />
        <Route path="/shipping_rule_edit" element={<Shipping_rule_edit />} />

        {/* <Route path="/billing_recharges" element={<Recharge />} /> */}
        <Route path="/billing_recharge" element={<Billing_recharge />} />

        {/* <Route
          path="/billing_weight_reconciliation"
          element={<Billing_weight_reconciliation />}
        /> */}
        <Route
          path="/billing_weight_reconciliation"
          element={<Billing_weight_reconciliation />}
        />

        {/* <Route
          path="/billing_cod_remittance"
          element={<Billing_cod_remittance />}
        /> */}
        {/* <Route path="/billing_passbook" element={<Billing_wallet />} /> */}
        <Route path="/billing_passbook" element={<Billing_passbook />} />
        <Route path="/billing_refunded" element={<Billing_refunded />} />

        {/* <Route path="/shipment_report" element={<Reports />} /> */}
        {/* <Route path="/shipment_report_v2" element={<Shipment_report_v2 />} /> */}
        <Route path="/shipment_report" element={<Shipment_report />} />

        {/* <Route path="/invoices_list" element={<Customer_invoice />} /> */}
        <Route path="/invoices_list" element={<Invoices_list />} />
        <Route path="/team" element={<Team />} />
        <Route path="/support_tickets" element={<Support_tickets />} />
        <Route path="/support_faq" element={<Support_faq />} />

        <Route path="/invoice_vendor" element={<Invoice_vendor />} />
        <Route path="/profile_update" element={<Profile_update />} />
        <Route path="/bank_details" element={<Bank_details />} />
        {/* <Route path="/user_kyc" element={<User_kyc />} /> */}

        <Route path="/kyc" element={<Kyc />} />
        <Route path="/create_order" element={<Create_order />} />

        <Route path="/billing_address" element={<Billing_address />} />
        <Route path="/change_password" element={<Change_password />} />
        <Route path="/sms_notification" element={<Sms_notification />} />

        {/* <Route path="/email_notification" element={<Email_notifications />} /> */}
        <Route path="/email_notification" element={<Email_notification />} />

        <Route path="/wallet_recharge" element={<Wallet_recharge />} />
        <Route path="/paynow" element={<PayNowButton />} />

        <Route path="/ndr" element={<Ndr_v2 />} />

        <Route exact path="/tracking/:tracking_no" element={<Tracking />} />
        <Route
          exact
          path="/international_order_import"
          element={<International_order_import />}
        />

        <Route exact path="/print_label" element={<Print_label />} />

        <Route
          exact
          path="/print_label_b2b/:shipment_id"
          element={<Print_label_b2b />}
        />

        <Route
          path="/international_orders"
          element={<International_orders />}
        />
        <Route
          path="/whatsapp_notification"
          element={<Whatsapp_notification />}
        />
        <Route exact path="/rate_card" element={<Rate_card />} />
        <Route
          exact
          path="/system_preference"
          element={<System_preference />}
        />

        {/* <Route path="/rate_card_B2C" element={<Rate_card_b2c />} /> */}
        {/* <Route path="/rate_card_B2B" element={<Rate_card_b2b />} /> */}
        {/* <Route exact path="/tickets" element={<Support_tickets />} /> */}
        <Route exact path="/redirect-handler" element={<RedirectHandler />} />

        <Route exact path="/create_ticket" element={<Create_ticket />} />
        <Route
          exact
          path="/support_create_ticket"
          element={<Support_create_ticket />}
        />

        <Route exact path="/create_team_user" element={<Create_team_user />} />

        <Route exact path="/activity_logs" element={<Activity_logs />} />
        <Route exact path="/settings" element={<Settings />} />
        <Route exact path="/manifest_add" element={<Manifest_add />} />
        <Route exact path="/manifest_list" element={<Manifest_list />} />
        <Route exact path="/bulk_lb_print" element={<Bulk_lb_print />} />
        <Route exact path="/bulk_orders_logs" element={<Bulk_order_log />} />
        {/* <Route exact path="/b2c_pricing" element={<Rate_card />} /> */}
        {/* <Route exact path="/rto_pricing" element={<Rto_pricing />} /> */}
        {/* <Route exact path="/b2b_pricing" element={<B2B_pricing />} /> */}

        <Route
          exact
          path="/shopify_direct_install"
          element={<ShopifyDirectInstall />}
        />
        <Route
          exact
          path="/system_prefrences"
          element={<System_prefrences />}
        />

        <Route exact path="/manifest_print" element={<Manifest_print />} />

        <Route
          exact
          path="/transaction_detail/:payout_id"
          element={<Transaction_detail />}
        />

        <Route
          exact
          path="/support_ticket_details"
          element={<Support_tickets_details />}
        />
      </Routes>
      <ShippingProgressBar />
    </Router>
  );
}

export default App;
